<template>
    <footer class="footer">
        <div class="separator">   </div>
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-6 col-lg-12">
                    <h2>{{ $t('footer.contact')}}</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="footer__block">
                        <div class="icon-wrapper">
                            <i class="mdi mdi-map-marker-outline"></i>
                        </div>
                        <p><strong>{{ $t('footer.address')}}</strong></p>
                        <p>12, Rue Préixhe</p>
                        <p>B-4681 Oupeye</p>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="footer__block">
                        <div class="icon-wrapper">
                            <i class="mdi mdi-phone"></i>
                        </div>
                        <p><strong>{{ $t('footer.call_us')}}</strong></p>
                        <p><a href="tel:080024550">+32 (0)800 / 24 550</a></p>
                        <p><a href="tel:+3243805510">+32 4 380 55 10</a></p>
                    </div>
                </div>

                <div class="col-12 col-sm-6 col-md-3">
                    <div class="footer__block">
                        <div class="icon-wrapper">
                            <i class="mdi mdi-email-outline"></i>
                        </div>
                        <p><strong>{{ $t('footer.mail_us')}}</strong></p>
                        <p><a href="mailto:info@minimax.be" target="_top">info@minimax.be</a></p>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="footer__block">
                        <div class="icon-wrapper">
                            <a href="https://www.facebook.com/MinimaxBelgium/" target="_blank"><span class="footer__icon"><i class="mdi mdi-facebook"></i></span></a>
                            <a href="https://be.linkedin.com/company/halutec" target="_blank"><span class="footer__icon"><i class="mdi mdi-linkedin"></i></span></a>
                            <a href="https://www.youtube.com/user/HaLuTec" target="_blank"><span class="footer__icon"><i class="mdi mdi-youtube"></i></span></a>
                            <a href="https://www.instagram.com/minimax_be/" target="_blank"><span class="footer__icon"><i class="mdi mdi-instagram"></i></span></a>
                        </div>

                        <p><strong><a target="_blank" :href="contactPageUrl">{{ $t('footer.more_contact_info')}}</a></strong></p>
                    </div>
                </div>
            </div>
           
        </div>
         <div class="footer__text">
                <div class="footer__text-left">
                    <img class="logo" src="/static/img/logo_minimax.png" alt="Minimax Client Dashboard" title="Minimax Client Dashboard" height="32px">
                </div>
                <div class="footer__text-right">
                    &copy; {{ new Date().getFullYear() }} {{ $t('footer.copyrights')}}
                </div>
        </div>
        <div class="locale_block hidden-xs hidden-sm hidden-md" v-if="!localeHidden">
            <locale-button class="locale_block__button--first" language="nl"/>
            <locale-button class="locale_block__button" language="fr"/>
            <button v-if="authenticated" @click="signOut" class="locale_block__logout">
                {{$t('menu.signout')}}
            </button>
        </div>
    </footer>
</template>



<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import {LOGOUT, IS_AUTHENTICATED} from '../../store/modules/auth';
    import LocaleButton from './LocaleButton';

    @Component({
        components: {
            LocaleButton,
        }
    })
    export default class TheFooter extends Vue {
        name = 'the-footer';
        @Prop() localeHidden;

        nlContactPageUrl = 'https://www.minimax.be/waterontharder/contact-wie-zijn-wij';
        frContactPageUrl = 'https://www.minimax.be/adoucisseur/contact-qui-sommes-nous/contact';
        locale = {}
        created (){
            this.locale = this.$i18n.locale;
        }

        get contactPageUrl() {
            if (this.locale == 'fr'){
                return this.frContactPageUrl;
            } else {
                return this.nlContactPageUrl;
            }
        }

        signOut() {
            this.$store.dispatch(LOGOUT).then(() => {
                this.$router.replace({
                    name: 'sign-in'
                });
            });
        }

        get authenticated() {
            return this.$store.getters[IS_AUTHENTICATED];
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/TheFooter.vue